import { render } from "./orderChannelModel.vue?vue&type=template&id=a545ba84"
import script from "./orderChannelModel.vue?vue&type=script&lang=js"
export * from "./orderChannelModel.vue?vue&type=script&lang=js"

import "./orderChannelModel.vue?vue&type=style&index=0&id=a545ba84&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__